var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconArchery = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1A202C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.592 19.278 3.394-3.394 1.132 1.132-3.394 3.394z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 9.667 1.75 6.416 4.667-4.666 1.166 1.166-4.666 4.667L16.333 19 21 5z"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArchery, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-archery.42f64407.svg";
export { ForwardRef as ReactComponent };